import { render } from "./RehabCategory.vue?vue&type=template&id=3d53b6ea&scoped=true"
import script from "./RehabCategory.vue?vue&type=script&lang=js"
export * from "./RehabCategory.vue?vue&type=script&lang=js"

import "./RehabCategory.vue?vue&type=style&index=0&id=3d53b6ea&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d53b6ea"]])